import React from 'react';
import Header from '../HeaderFooter/Header';
import Footer from '../HeaderFooter/Footer';
import { useNavigate } from 'react-router-dom';
import '../../styles/serviceCallStyles/ServiceCallLayout.css';

const ServiceCallLayout = ({ children, activeTab, setActiveTab, tabsTitle = 'Service Call' }) => {

  const navigate = useNavigate(); 

  const handleCreateNewServiceClick = () => {
    setActiveTab('Create New Service');
    navigate('/servicecall'); 
  };

  return (
    <div className="servicecall-layout-container">
      <Header />
      <div className="servicecall">
        <div className="serv-container">
          <h2 className="serv-title">{tabsTitle}</h2>
          <div className="service">
            <button
              className={`serv-item ${activeTab === 'Create New Service Call' ? 'active' : ''}`}
              onClick={handleCreateNewServiceClick}
            >
              <img src="/images/back.svg" alt="New Project Icon" className="service-icon" />
              Create New Service Call
            </button>
            <img src="/images/Rectangle.png" alt="New Project Icon" className="serv-icon" />
          </div>
        </div>
        <div className="content-inner">{children}</div>
      </div>
      <Footer />
    </div>
  );
};

export default ServiceCallLayout;
